<svg class="mri-icon__svg">
  <use [attr.href]="url" />
</svg>
